import { createFeatureSelector, createSelector } from '@ngrx/store';

// Import State instead of CustomerSettingsState and remove adapter import
import {
  CUSTOMER_SETTINGS_FEATURE_KEY,
  type CustomerSettingsState,
} from './customer-settings.reducer';

// Lookup the 'CustomerSettings' feature state managed by NgRx
// Update type hint for feature selector
export const selectCustomerSettingsState =
  createFeatureSelector<CustomerSettingsState>(CUSTOMER_SETTINGS_FEATURE_KEY);

// Remove entity adapter selectors

// Renamed selector to match our state property
export const selectCustomerLoading = createSelector(
  selectCustomerSettingsState,
  (state: CustomerSettingsState) => state.loading
);

// Renamed selector and updated type hint
export const selectCustomerError = createSelector(
  selectCustomerSettingsState,
  (state: CustomerSettingsState) => state.error
);

// Removed entity-specific selectors (selectAll, selectEntities, selectSelectedId, selectEntity)

// Added selector for the customer metadata object
export const selectCustomerSettings = createSelector(
  selectCustomerSettingsState,
  (state: CustomerSettingsState) => state.customerMetadata
);
